import { render, staticRenderFns } from "./Wp_jd_changelink.vue?vue&type=template&id=58924ec0&scoped=true&"
import script from "./Wp_jd_changelink.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_changelink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58924ec0",
  null
  
)

export default component.exports